export default {
    "name": "Frog Tactics",
    "short_name": "Frog Tactics",
    "scope": "./",
    "start_url": "index.html",
    "display": "fullscreen",
    "background_color": "#222",
    "theme_color": "#222"
}
